<template>
  <div class="c-campaign-widget-traffic-form">
    <table class="w-full mb-4 table-auto border-separate" :class="$style.table">
      <thead>
      <tr>
        <th>Name</th>
        <th>Preview</th>
        <th>Traffic Share</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(id, index) in widgetItemsList" :key="id + index">
        <td>
          <div><span>{{ widgetItems[id].name }}</span></div>
        </td>
        <td>
          <div class="w-[142.88px] h-[74.4px] relative rounded-xl bg-onvocado-secondary-light">
            <WidgetStepPreview :widget="widgetItems[id]" :needs-reformatting="true"/>
          </div>
        </td>
        <td>
          <EditBlockNumericInput
              :value="percentageShares[index]"
              class="mx-2 inline-block"
              :input-class-list="'w-12'"
              :min="0"
              :max="100"
              @input="updateShare(id, $event)"/>
          <span>%</span>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="flex justify-end">
      <button class="btn primary big" @click="saveChanges">Done</button>
    </div>
  </div>
</template>

<script>
import WidgetStepPreview from '@components/Widgets/_global/WidgetStepPreview/WidgetStepPreview.vue'
import { EditBlockNumericInput } from '@components/EditBuildingBlocks/all'
import { mapActions } from 'vuex'

export default {
  name: 'WidgetTrafficShareForm',
  components: {
    WidgetStepPreview,
    EditBlockNumericInput,
  },
  data() {
    return {
      percentageShares: [],
    }
  },
  computed: {
    widgetItems() {
      return this.$store.getters['campaign/widget/getWidgetItems']
    },
    widgetItemsList() {
      return this.$store.getters['campaign/widget/getWidgetItemsList']
    },
    targetWidgetID() {
      return this.$store.state.campaign.widget.targetWidgetID
    },
  },
  created() {
    this.initializeShares()
  },
  methods: {
    ...mapActions('campaign/widget', ['updateWidgetDetails', 'saveWidget']),
    initializeShares() {
      this.widgetItemsList.forEach((id, index) => {
        this.percentageShares.push((this.widgetItems[id].trafficShare * 100).toFixed(0))
      })
    },
    updateShare(id, newValue) {
      const index = this.widgetItemsList.indexOf(id)
      newValue = Math.max(0, Math.min(100, parseFloat(newValue)))
      this.$set(this.percentageShares, index, newValue)

      // Automatically adjust the other share
      this.autoAdjustShares(index)
    },
    autoAdjustShares(changedIndex) {
      const otherIndex = changedIndex === 0 ? 1 : 0 // Assuming only two shares
      const newOtherValue = (100 - this.percentageShares[changedIndex]).toFixed(2)
      this.$set(this.percentageShares, otherIndex, newOtherValue)
    },
    saveChanges() {
      this.widgetItemsList.forEach((id, index) => {
        const shareAsDecimal = this.percentageShares[index] / 100  // Convert the percentage to a decimal

        // Update the widget details in the Vuex store
        this.updateWidgetDetails({
          id,
          path: ['trafficShare'],  // Assuming the Vuex store expects an object with these properties
          value: shareAsDecimal,
        })

        // Save each widget if necessary
        if (this.targetWidgetID !== parseInt(id)) {
          this.saveWidget(id)
        }
      })

      // Close the modal or emit an event after successful save
      this.$emit('close-modal')  // Adjust as necessary based on your component's needs
    },
  },
}
</script>

<style lang="scss">
.c-campaign-widget-traffic-form {
  .el-form .el-form-item {
    label {
      @apply font-medium;
    }
  }
}
</style>

<style lang="scss" module>
.table {
  border-spacing: 0.5rem 0.5rem;
}
</style>